import Vue from 'vue';
import Popper from 'vue-popperjs';
import './../../assets/css/popper.css';

Vue.component('popper', Popper);

